import React, { useEffect, useState } from "react";
import "./Contact.css";
import bannerImg from "../../Image/contact-us-customer-support-enquiry-hotline-concept (1).jpg";

const Contact = () => {
  const [formData, setFormData] = useState({
    fullName: "",
    email: "",
    phone: "",
    query: "",
  });

  /* 🔴 ADDED: PAGE HAMESHA TOP SE OPEN HOGA */
  useEffect(() => {
    window.scrollTo({
      top: 0,
      behavior: "instant", // smooth chahiye ho to "smooth"
    });
  }, []);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    alert(`Thank you, ${formData.fullName}! Your query has been submitted.`);
    setFormData({ fullName: "", email: "", phone: "", query: "" });
  };

  return (
    <div className="contact-page">
      {/* Banner Section */}
      <div className="contact-banner">
        <div className="contact-banner-img">
          <img src={bannerImg} alt="Contact Support" />
        </div>
      </div>

      {/* Info + Form */}
      <div className="contact-container">
        {/* Left Info Section */}
        <div className="contact-info">
          <div className="info-block">
            <h3>📧 Office Email</h3>
            <p>ujalaebikes@gmail.com</p>
          </div>

          <div className="info-block">
            <h3>📞 Office Phone</h3>
            <p>+91 800-953-9867 | +91 800-953-9047</p>
          </div>

          <div className="info-block">
            <h3>📍 Office Address</h3>
            <p>
              Main showroom- Beli farm, New, Jail Road, Sivlar, Gosainganj,
              Lucknow, Uttar Pradesh -226501
            </p>
            <p>
              <h3>Branch</h3> - VIP Road Alambagh
            </p>
          </div>
        </div>

        {/* Right Form Section */}
        <div className="contact-form">
          <h2>Contact Us</h2>
          <form onSubmit={handleSubmit}>
            <input
              type="text"
              name="fullName"
              placeholder="Full Name"
              value={formData.fullName}
              onChange={handleChange}
              required
            />

            <input
              type="email"
              name="email"
              placeholder="Email Address"
              value={formData.email}
              onChange={handleChange}
              required
            />

            <input
              type="tel"
              name="phone"
              placeholder="Phone Number"
              value={formData.phone}
              onChange={handleChange}
              required
            />

            <textarea
              name="query"
              placeholder="Your Query"
              rows="5"
              value={formData.query}
              onChange={handleChange}
              required
            ></textarea>

            <button type="submit">Send</button>
          </form>
        </div>
      </div>

      {/* Map full width */}
      <div className="map-container">
        <iframe
          title="Ujala - E - Bikes"
          src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3561.1971299680354!2d80.9156586!3d26.801851100000004!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x399bfd12a9a24cc9%3A0x544f95c98ac6b990!2sUJALA%20E%20BIKES%20%7C%20Electric%20Vehicle%20Showroom%20%7C%20Electric%20Vehicles!5e0!3m2!1sen!2sin!4v1768291246180!5m2!1sen!2sin"
          width="100%"
          height="400"
          style={{ border: 0, borderRadius: "12px" }}
          allowFullScreen=""
          loading="lazy"
          referrerPolicy="no-referrer-when-downgrade"
        ></iframe>
      </div>
    </div>
  );
};

export default Contact;
